import React from 'react';
import { Container } from 'react-bootstrap';
import Button from '../../../components/Button';
import HealthSavingsModal from './HealthSavingsModal';

const HealthSavingsModalDemo = () => {
  const [showHealthSavingsModal, setShowHealthSavingsModal] =
    React.useState<boolean>(false);

  const handleShowHealthSavingsModal = () => setShowHealthSavingsModal(true);
  const handleCloseHealthSavingsModal = () => setShowHealthSavingsModal(false);

  return (
    <Container>
      <Container className="mt-10">
        <h4>Health Savings Modal</h4>
        <Button onMouseDown={handleShowHealthSavingsModal}>Open Modal</Button>
        <HealthSavingsModal
          showHealthSavingsModal={showHealthSavingsModal}
          handleCloseHealthSavingsModal={handleCloseHealthSavingsModal}
        />
      </Container>
    </Container>
  );
};

export default HealthSavingsModalDemo;
